(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["latrove-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('latrove-product-search')) {
    customElements.define('latrove-product-search', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        this.field = this.querySelector('input[type="search"]');
        this.panel = this.querySelector('.lt-search-results');
        this.content = this.querySelector('.lt-search-content');
        this.status = this.querySelector('.lt-search-status');
        this.clear = this.querySelector('[type="reset"]');
        this.sequence = 0;
        const on = (el, type, fn) => el.addEventListener(type, fn, {signal:this.events.signal});
        on(this.field, 'input', () => {
          clearTimeout(this.timer);
          this.request?.abort();
          this.sequence++;
          this.clear.hidden = !this.field.value;
          this.close();
          if (this.field.value.trim()) this.timer = setTimeout(() => this.search(), 250);
        });
        on(this.field, 'focus', () => { if (this.field.value.trim()) this.search(); });
        on(this.querySelector('form'), 'reset', event => {
          event.preventDefault();
          clearTimeout(this.timer);
          this.request?.abort();
          this.sequence++;
          this.field.value = '';
          this.clear.hidden = true;
          this.close();
          this.field.focus();
        });
        on(this.querySelector('form'), 'submit', event => {
          if (!this.field.value.trim()) { event.preventDefault(); this.field.focus(); }
        });
        on(this.panel, 'pointerdown', event => { if (event.target.closest('a,button')) event.preventDefault(); });
        on(document, 'pointerdown', event => { if (!this.contains(event.target)) this.close(); });
        on(this, 'focusout', event => { if (!this.contains(event.relatedTarget)) this.close(); });
        on(this, 'keydown', event => {
          if (event.key === 'Escape') { this.field.focus(); this.close(); this.request?.abort(); clearTimeout(this.timer); this.sequence++; }
          if (!['ArrowDown','ArrowUp'].includes(event.key) || this.panel.hidden) return;
          const items = [this.field,...this.content.querySelectorAll('a'),this.querySelector('.lt-search-all')];
          const current = items.indexOf(document.activeElement);
          event.preventDefault();
          items[(current + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length].focus();
        });
        this.clear.hidden = !this.field.value;
      }
      close() { this.panel.hidden = true; this.field.setAttribute('aria-expanded','false'); }
      async search() {
        const query = this.field.value.trim();
        if (!query) return;
        this.request?.abort();
        this.request = new AbortController();
        const version = ++this.sequence;
        this.content.replaceChildren();
        this.status.textContent = this.dataset.loading;
        this.panel.hidden = false;
        this.field.setAttribute('aria-expanded','true');
        const url = new URL(this.dataset.endpoint,location.origin);
        url.search = new URLSearchParams({q:query,'resources[type]':'product','resources[limit]':'4',section_id:'latrove-search-suggestions'});
        try {
          const response = await fetch(url,{signal:this.request.signal});
          if (!response.ok) throw new Error('Search unavailable');
          const html = new DOMParser().parseFromString(await response.text(),'text/html');
          if (version !== this.sequence) return;
          const results = html.querySelector('[data-lt-suggestions]');
          if (!results) throw new Error('Search unavailable');
          this.status.textContent = results.dataset.message;
          this.content.replaceChildren(...results.childNodes);
        } catch (error) {
          if (error.name !== 'AbortError' && version === this.sequence) this.status.textContent = this.dataset.error;
        }
      }
      disconnectedCallback() { this.events?.abort(); this.request?.abort(); clearTimeout(this.timer); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
